<template>
  <div class="form-group">
    <label
      v-if="label"
      :for="id"
    >
      {{label}}
    </label>

    <input
      :value="value"
      :type="type"
      :class="classInput"
      :id="id"
      :placeholder="placeholder || label"
      :min="min"
      :max="max"
      @input="$emit('input', $event.target.value)"
    >

    <div
      v-if="error"
      class="invalid-feedback"
    >
      {{error}}
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
        required: true,
      },
      error: {
        type: String,
      },
      value: {},
      type: {
        type: String,
      },
      label: {
        type: String,
      },
      placeholder: {
        type: String,
      },
      min: {
        type: [Number, String],
      },
      max: {
        type: [Number, String],
      },
    },

    computed: {
      classInput() {
        return {
          'form-control': true,
          'is-invalid': this.error,
        }
      },
    },
  }
</script>

<style>

</style>
